<template>
  <a :href="record.link">
    <div class="z-10 px-4 py-3 bg-white border-b border-gray-200 hover:bg-default-200">
      <div class="flex justify-between">
        <small class="font-semibold">{{ record.type }}</small>
        <small class="font-semibold">{{ record.publication_at }}</small>
      </div>
      <h6 class="mt-1 mb-0 text-default-500">{{ record.title }}</h6>
      <small>{{ record.abstract }}</small>
      <div class="flex justify-between">
        <small class="font-semibold">{{ record.category }}</small>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'CardSearchComponent',
  props: ["record"],
};
</script>

<style scoped>
</style>
